
import {computed, ComputedRef, defineComponent, onMounted, Ref, ref, watch, reactive} from 'vue'
import {useStore} from 'vuex'
import {useI18n} from 'vue-i18n'

import {message, Form} from 'ant-design-vue'
import {LoadingOutlined, UploadOutlined, DownloadOutlined} from '@ant-design/icons-vue'

import downloadfile from '@/utils/download'

import {StateType as HomeStateType} from '../../store'
import {PaginationConfig} from '../../data'

interface CollectionInfoData {
  columns: any
  list: any
  loading: Ref<boolean>
  handleExport: (e: MouseEvent) => void
}

interface paginationDir {
  pageNo: number
  pageSize: number
}

export default defineComponent({
  name: 'collectionInfo',
  components: {LoadingOutlined, UploadOutlined, DownloadOutlined},
  setup(): CollectionInfoData {
    const loading = ref<boolean>(false)
    const store = useStore<{
      Home: HomeStateType
    }>()
    const pageNum = reactive<paginationDir>({pageNo: 1, pageSize: 10})
    const userMsg = JSON.parse(String(localStorage.getItem('userMsg'))) || {}
    const {userCode} = userMsg
    const columns = [
      {title: '服务省份', dataIndex: 'province'},
      {title: '服务城市', dataIndex: 'city'},
      {title: '服务区县', dataIndex: 'district'},
      {title: '起揽件数', dataIndex: 'pickStartValue'},
      {title: '服务方式', dataIndex: 'pickupWay'},
      {title: '部分揽收区域描述', dataIndex: 'remark', width: 200},
    ]

    //获取地址
    const list = computed<any[]>(() => store.state.Home.pickupList)
    // console.log('store.state.Home.pickupList',store.state.Home.pickupList)
    const getExplainTab = async () => {
      try {
        const res: boolean = await store.dispatch('Home/pickupScopeFn')
      } catch (error) {
        message.warning('获取上门揽收范围失败！')
      }
    }

    //导出
    const handleExport = (e: MouseEvent) => {
      downloadfile({
        params: {userCode: userMsg?.userCode},
        url: '/seller/v1/homePage/pickupScopeExport',
        meth: 'post',
        filename: `上门揽收范围${new Date().getTime()}.xlsx`,
        type: 'text/plain',
      })
    }

    onMounted(() => {
      getExplainTab()
    })

    return {
      list,
      columns,
      handleExport,
      loading,
    }
  },
})
